import {ActionReducerMap, Action} from '@ngrx/store';

import * as actionsUi from './mandantenverwaltung-technik.actions.ui';
import {AzureAdMandantOptions} from '../../../clients/api';
import {SmtpMandantOptions, TroubleTicketMandantOptions} from '../../../clients/kommunikation';
import {APP_RESET_ACTION} from '@orga-app/appstart/actions';
import {GET_MANDANT_CONFIG, GET_MANDANT_CONFIG_ERFOLGREICH, GET_MANDANT_CONFIG_FEHLER, GetMandantConfigErfolgreichAction} from '../../../client-ngrx/api';
import {KommunikationConfigTypes, MandantenConfigTypes} from '../../../client-constants';
import AZURE_AD_MANDANT_OPTIONS = MandantenConfigTypes.AZURE_AD_MANDANT_OPTIONS;
import SMTP_MANDANT_OPTIONS = KommunikationConfigTypes.SMTP_MANDANT_OPTIONS;
import TROUBLE_TICKET_MANDANT_OPTIONS = KommunikationConfigTypes.TROUBLE_TICKET_MANDANT_OPTIONS;

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};


export interface PageState {
    mandantConfigLaden: boolean;
    mandantConfigFehler: boolean;

    azureAdConfig: AzureAdMandantOptions;
    smtpConfig: SmtpMandantOptions;
    troubleTicketConfig: TroubleTicketMandantOptions;

}

export const initialPageState: PageState = {
    mandantConfigLaden: false,
    mandantConfigFehler: false,

    azureAdConfig: null,
    smtpConfig: null,
    troubleTicketConfig: null,
};


export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState> initialPageState);
        }

        case GET_MANDANT_CONFIG: {
            return Object.assign({}, state, <PageState> {
                mandantConfigLaden: true,
                mandantConfigFehler: false
            });
        }

        case GET_MANDANT_CONFIG_ERFOLGREICH: {
            const a = <GetMandantConfigErfolgreichAction> action;

            // console.log('Mandant Config erfolgreich: ', a);

            let azureAdConfig: AzureAdMandantOptions = Object.assign({}, state.azureAdConfig);
            if (a.payload[AZURE_AD_MANDANT_OPTIONS] !== undefined && a.payload[AZURE_AD_MANDANT_OPTIONS] !== null) {
                azureAdConfig = a.payload[AZURE_AD_MANDANT_OPTIONS];
            }

            let smtpConfig: SmtpMandantOptions = Object.assign({}, state.smtpConfig);
            if (a.payload[SMTP_MANDANT_OPTIONS] !== undefined && a.payload[SMTP_MANDANT_OPTIONS] !== null) {
                smtpConfig = a.payload[SMTP_MANDANT_OPTIONS];
            }

            let troubleTicketConfig: TroubleTicketMandantOptions = Object.assign({}, state.troubleTicketConfig);
            if (a.payload[TROUBLE_TICKET_MANDANT_OPTIONS] !== undefined && a.payload[TROUBLE_TICKET_MANDANT_OPTIONS] !== null) {
                troubleTicketConfig = a.payload[TROUBLE_TICKET_MANDANT_OPTIONS];
            }


            return Object.assign({}, state, <PageState> {
                mandantConfigLaden: false,
                mandantConfigFehler: false,
                azureAdConfig,
                smtpConfig,
                troubleTicketConfig
            });
        }

        case GET_MANDANT_CONFIG_FEHLER: {
            return Object.assign({}, state, <PageState> {
                mandantConfigLaden: false,
                mandantConfigFehler: true
            });
        }


        case actionsUi.AZURE_AD_CONFIG_INPUT: {
            const a = <actionsUi.AzureAdConfigInput> action;

            return Object.assign({}, state, <PageState> {
                azureAdConfig: a.payload
            });
        }

        case actionsUi.SMTP_CONFIG_INPUT: {
            const a = <actionsUi.SmtpConfigInput> action;

            return Object.assign({}, state, <PageState> {
                smtpConfig: a.payload
            });
        }

        case actionsUi.TROUBLE_TICKET_CONFIG_INPUT: {
            const a = <actionsUi.TroubleTicketConfigInput> action;

            return Object.assign({}, state, <PageState> {
                troubleTicketConfig: a.payload
            });
        }

        default: {
            return state;
        }
    }
}
